import { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SPEAKER_CLICK } from "../../../AppConstants/AnalyticsEventName";
import { AnalyticsContext } from "../../../contexts/Analytics/AnalyticsContextProvider";
import { isMobileDevice } from "../../../utils/getPlatformInfo";
import styles from "./index.module.scss";
import { trimString } from "../../../utils/common.utils";
import { SPEAKER_CLICK_EVENT } from "../../../Clevertap/EventNames.ts";
import { getSpeakerData } from "../../../Clevertap/EventHandler.ts";

let bannerStyle = {
  left: "50%",
  top: "50%",
  marginLeft: 0,
  height: isMobileDevice ? "auto" : "30rem",
  maxHeight: "30rem",
};

function AllSpeakers({ banner, speakerCardList, handleSpeakerClose, webinar }) {
  const { addGAWithUserInfo, addCleverTapAnalytics } = useContext(AnalyticsContext);
  let history = useHistory();
  const { pathname, search = "", hash = "", state } = useLocation();

  const handleClick = (speaker) => {
    addGAWithUserInfo(SPEAKER_CLICK, { eventId: speaker.id });
    addCleverTapAnalytics(SPEAKER_CLICK_EVENT, getSpeakerData({
      "Speaker Id": speaker.id,
      "Speaker Name": speaker.name,
    }))
    return history.push({
      pathname: `/speakerInfo/${speaker.id}`,
      search: search,
    });
  };

  return (
    <>
      <div
        style={{ overflow: "hidden" }}
        onClick={handleSpeakerClose}
        className="modalOverlayWithTint"
      ></div>
      <div
        style={banner ? bannerStyle : {}}
        className={`${styles.borderSpeaker}`}
      >
        <div className={styles.AllSpeakerPopUpTag}>
          <div className={styles.heading}>
            <div className={styles.left}>Speaker Details</div>
            <div className={styles.close} onClick={handleSpeakerClose}>Close</div>
          </div>
          <div className={styles.separater} />
          <div className={styles.AllSpeakerWrapper}>
            {speakerCardList.map((speaker) => {
              return (
                <div
                  onClick={() => handleClick(speaker)}
                  className={styles.AllSpeakerCard}
                  key={speaker.name}
                >
                  <div className={styles.left}>
                    <img src={speaker.photoUrl} alt={speaker.name} />
                  </div>
                  <div className={styles.right}>
                    <div className={styles.name}>{speaker.name}</div>
                    <div className={styles.speciality}>
                      {speaker.designation}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default AllSpeakers;
